import { generateId } from '@freelancer/datastore/testing/helpers';
import type { SwiftIdApplicantProfile } from './swift-id-applicant.model';

/**
 * Generates a SwiftID applicant object
 */
export function generateSwiftIdApplicantObject({
  id = generateId(),
  applicationId = generateId(),
  userId = generateId(),
  title = 'Mr',
  givenName = 'Joshy',
  surname = 'Dorsy',
  hasNoMiddleName = true,
  dateOfBirth = '01/01/1975',
  emailAddress = 'jdoros@freelancer.com',
  residentialAddress = {
    streetAddress: 'Lovely Churches',
    cityOrSuburb: 'Lovely Banks',
    state: 'VIC',
    postCode: '3213',
    countryCode: 'AU',
  },
  contactDetails = {
    mobilePhoneCountryCode: 'AU',
    mobilePhone: '412345678',
  },
  countryOfBirth = 'AU',
  isTaxResidentOfAustralia = true,
  isCountryOfCitizenshipSameAsCountryOfBirth = true,
  isTaxResidentOfAForeignCountry = false,
  isGovernmentAffiliated = false,
  isAsxAffiliated = false,
  isTfnExempted = false,
  occupationType = 'OccupationTypeBusinessOwners',
  occupationCategory = 'OccupationCategoryCafeAndRestaurant',
  sourceOfWealth = 'GbstInvestmentsSavings',
  isPrimary = false,
  applicationRelationships = [],
}: Partial<SwiftIdApplicantProfile>): SwiftIdApplicantProfile {
  return {
    id,
    applicationId,
    userId,
    title,
    givenName,
    surname,
    hasNoMiddleName,
    dateOfBirth,
    emailAddress,
    residentialAddress,
    contactDetails,
    countryOfBirth,
    isTaxResidentOfAustralia,
    isCountryOfCitizenshipSameAsCountryOfBirth,
    isTaxResidentOfAForeignCountry,
    isGovernmentAffiliated,
    isAsxAffiliated,
    isTfnExempted,
    occupationType,
    occupationCategory,
    sourceOfWealth,
    isPrimary,
    applicationRelationships,
  };
}
